import { FC } from "react";
import LoanReviewField from "./LoanReviewField";
import { Divider, Tooltip } from "../../../components";
import { CloseIcon, InfoIcon } from "../../../assets/icons";
import EditButton from "./EditButton";

type DeleteButtonProps = {
  onClick?(): void;
};

export const DeleteButton: FC<DeleteButtonProps> = ({ onClick }) => {
  return (
    <div
      className="cx-group cx-inline-flex cx-w-8 cx-h-8 cx-min-w-8 cx-min-h-8 cx-flex-none cx-shrink-0 cx-items-center cx-justify-center cx-rounded-full cx-border cx-border-stroke-error cx-cursor-pointer hover:cx-bg-background-error"
      onClick={onClick}
    >
      <CloseIcon className="cx-w-4 cx-h-4 cx-text-text-error group-hover:cx-text-text-inverse cx-leading-none" />
    </div>
  );
};

type Props = {
  title: string;
  name: string;
  email: string;
  phoneNumber: string;
  onEdit?: () => void;
  onDelete?: () => void;
  tooltipText?: string;
};

const ShareholderInfo: FC<Props> = ({
  title,
  name,
  email,
  phoneNumber,
  onEdit,
  onDelete,
  tooltipText,
}) => {
  return (
    <div className="cx-flex cx-flex-col">
      <div className="cx-flex cx-items-center cx-gap-1 cx-mt-6 cx-mb-1">
        <div className="cx-text-lg cx-font-semibold cx-text-text-primary">
          {title}
        </div>
        {tooltipText && (
          <Tooltip
            className="cx-max-w-[320px]"
            content={tooltipText}
            trigger={
              <button
                type="button"
                className="cx-w-6 cx-h-6 cx-flex cx-shrink-0 cx-items-center cx-justify-center cx-rounded-full cx-text-brand-primary-regular hover:cx-opacity-90"
                aria-label="More information"
              >
                <InfoIcon className="cx-w-4 cx-h-4" />
              </button>
            }
            position="top left"
          />
        )}
      </div>
      <LoanReviewField value={name} label="Name" />
      <Divider />
      <LoanReviewField value={phoneNumber} label="Phone number" />
      <Divider />
      <LoanReviewField value={email} label="Email" />
      <div className="cx-flex cx-flex-row cx-gap-2 cx-mt-2 cx-mb-6">
        {!!onEdit && <EditButton onClick={onEdit} />}
        {!!onDelete && <DeleteButton onClick={onDelete} />}
      </div>
    </div>
  );
};

export default ShareholderInfo;
